// ── LoanForm ──
import { useState } from "react";
import { B } from "../../../shared/theme";
import { Btn, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

export const LoanForm = ({ initial, accountid, readOnly }) => {
    const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
    const [f, set] = useFreshForm(initial||{loannumber:"",originalfundingdate:"",maturityDate:"",status:"Current",accountid,hasparticipation:false,participationrole:""}, "Loans");
    // percent shown in the input (e.g. "50"); f.participationpct stays a decimal (0.50) for the DB
    const [pctText, setPctText] = useState(
      initial?.participationpct != null ? String(+(initial.participationpct * 100).toFixed(6)) : ""
    );
    const ST = ({ title }) => <div style={{ fontSize:11, fontWeight:600, color:B.cyanDark, textTransform:"uppercase", letterSpacing:"0.06em", marginTop:18, marginBottom:8, paddingBottom:4, borderBottom:"1.5px solid "+B.cyanLight, gridColumn:"1/-1" }}>{title}</div>;

    return <Modal title={readOnly?"View Loan":initial?"Edit Loan":"Add Loan"} onClose={closeModal} wide
      onEdit={readOnly&&role.canEdit?()=>{ closeModal(); setModal({type:"loan-edit",rec:initial,accountid,onDone:modal.onDone}); }:null}>
      <ReadOnlyForm readOnly={readOnly}>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr", gap:"0 24px" }}>

          <ST title="Loan Details" />
          {/* Read-only on edit, because the system owns this number. On an add
              it has not been assigned yet, and saying so beats a blank box that
              looks like a field somebody forgot to fill in. */}
          <Field label="Loan Number">
            <div style={{ padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", background:"#f5f5f5", color:"#888" }}>
              {initial ? (f.loannumber || "—") : "Assigned when you save"}
            </div>
          </Field>

          <ST title="Dates" />
          <div /><div />
          <ST title="Participation" />
          <div style={{ gridColumn:"1/-1", display:"flex", gap:28, marginBottom:8 }}>
            <label style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
              <input type="checkbox" checked={!!f.hasparticipation} onChange={e=>set("hasparticipation")(e.target.checked)} /> Participation
            </label>
          </div>
          {!!f.hasparticipation&&<>
            <Field label="Participation Role">
              <FSelect value={f.participationrole||""} onChange={set("participationrole")} options={["","Lead","Participant"]} />
            </Field>
            <Field label="Participation %">
              <input
                type="number" step="0.01" min="0" max="100"
                disabled={readOnly}
                value={pctText}
                onChange={e=>{ const t=e.target.value; setPctText(t); set("participationpct")(t===""?null:Number(t)/100); }}
                placeholder="e.g. 50"
                style={{ width:"100%", padding:"7px 10px", fontSize:13, borderRadius:4, border:"1px solid #ddd", boxSizing:"border-box" }}
              />
            </Field>
            <div /><div />
          </>}

        </div>
      </ReadOnlyForm>
      {!readOnly&&error&&<div style={{ color:"#993C1D",fontSize:12,marginBottom:8,marginTop:8 }}>{error}</div>}
      <div style={{ display:"flex",gap:8,justifyContent:"flex-end",marginTop:16 }}>
        <Btn onClick={closeModal}>{readOnly?"Close":"Cancel"}</Btn>
        {!readOnly&&<Btn disabled={saving} onClick={()=>saveRec("saveLoan",f,initial?"Edited":"Added","Loans",
          // On an ADD the form has no loan number to report — the server assigns
          // it and hands it back, so the audit line is built from the response
          // rather than from a field that is still empty.
          r=>(initial?"Updated":"Added")+" loan: "+(f.loannumber||r.loannumber||"(number not assigned)"),
          modal.onDone)} variant="primary">{saving?"Saving...":"Save"}</Btn>}
      </div>
    </Modal>;
  };
